import React, { useState } from 'react';
import { Slider, ClickAwayListener, Popover, Box } from '@mui/material';
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

export default function OutLevelSelectorClickAway({ value, setValue }) {
    // const [value, setValue] = useState(100);
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'slider-popover' : undefined;

    return (
        <div>
            <TextField
                value={`${value}%`}
                label="Out Level"
                variant="outlined"
                sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}
                onClick={handleClick}
            />

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <ClickAwayListener onClickAway={handleClose}>
                    <Box width={300}>
                        <Typography gutterBottom style={{ margin: '10px' }}>Out Level ({value}%)</Typography>
                        <Slider
                            value={value}
                            min={30}
                            max={200}
                            step={2}
                            valueLabelDisplay="auto"
                            onChange={handleChange}
                            valueLabelFormat={(value) => `${value}%`}
                            style={{ width: '80%', margin: '30px' }}
                        />
                    </Box>
                </ClickAwayListener>
            </Popover>
        </div>
    );
}
